<template>
    <div class="message" @click="messageClick()">
       {{message}}
    </div>
</template>

<script>
export default {
    name: 'LogoutIndex',
    data() {
        return {
            message:'待機時間をすぎました。\n自動ログアウト済'
        }
    },
    methods:{
        messageClick(){
            window.document.location = "/ss/menu.php";
        }
    }

}
</script>

<style scoped>
.message {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.6vw;
    white-space: pre-wrap;
}
</style>